import * as Types from '../../../../../../../../types/gql';

export type AbroadBankDepositDetails = {
  bankName: string;
  swift: string;
  bankAddress: string;
  intermediaryBankName?: Types.Maybe<string>;
  intermediarySwift?: Types.Maybe<string>;
  recipient: string;
  accountOfReceiver?: Types.Maybe<string>;
  recipientAddress: string;
  purposeOfPayment: string;
  correspondentAccount?: Types.Maybe<string>;
};

export type BankDetailsVariables = Types.Exact<{ [key: string]: never }>;

export type BankDetails = {
  currentUser?: Types.Maybe<{ id: string }>;
  clearing?: Types.Maybe<{
    depositInstruments?: Types.Maybe<
      Array<{
        type: Types.ClearingDepositInstrumentType;
        currency: string;
        details?: Types.Maybe<AbroadBankDepositDetails>;
      }>
    >;
  }>;
};
